import { Navigate } from 'react-router-dom'
import { isPlatformAdmin } from '@/utils/platformAdminAuth'
import { getPlatformDashboardPath, getPlatformLoginPath } from '@/config/platform'

export function PlatformEntry() {
  if (isPlatformAdmin()) {
    return <Navigate to={getPlatformDashboardPath()} replace />
  }
  return <Navigate to={getPlatformLoginPath()} replace />
}
